<!--
 * @Author:
 * @Description: Button component that supports border, icon and custom text
 * @Date: 2025-01-21 09:59:05
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-merchant-web/src/componentsV2/base-cmps/button/index.vue
-->
<template>
  <div class="rhcn-button" :class="{
    'rhcn-button--border': border,
    'rhcn-button--disabled': disabled,
    'rhcn-button--hover': hoverColor
  }" :style="buttonStyle" @click="clickHandler" :tabindex="disabled ? -1 : 0" role="button">
    <img v-if="icon" class="rhcn-button__icon" :src="icon" :alt="iconAlt">
    <span class="rhcn-button__text">
      <slot>{{ text }}</slot>
    </span>
  </div>
</template>

<script>
export default {
  name: 'rhcn-button-v2',
  props: {
    // 按钮文字
    text: {
      type: String,
      default: '',
    },
    // 是否显示边框
    border: {
      type: Boolean,
      default: true,
    },
    // 边框颜色
    borderColor: {
      type: String,
    },
    // 文字颜色
    textColor: {
      type: String,
      default: '#000',
    },
    // 图标图片地址
    icon: {
      type: String,
      default: '',
    },
    // 图标替代文本
    iconAlt: {
      type: String,
      default: 'icon',
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false,
    },
    // 鼠标悬停颜色
    hoverColor: {
      type: String,
      default: 'rgb(208, 213, 221,0.05)',
    },
  },
  computed: {
    buttonStyle() {
      if (!this.border) return {};
      return {
        borderColor: this.borderColor,
        color: this.textColor,
        '--hover-bg-color': this.hoverColor,
      };
    },
  },
  methods: {
    // 点击事件处理
    clickHandler() {
      if (!this.disabled) {
        this.$emit('click');
      }
    },
  },
};
</script>

<style scoped lang="scss">
.rhcn-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 24px;
  border-radius: 4px;
  border: none;
  color: rgb(255, 255, 255);
  cursor: pointer;
  transition: all 0.3s;
  user-select: none;
  outline: none;
  font-family: "Urbanist";
  font-weight: 400;
  font-size: 16px;
  font-style: normal;
  text-transform: none;

  &:hover {
    background-color: var(--hover-bg-color);

  }

  &:focus {
    background-color: var(--hover-bg-color);

  }

  &--border {
    border: 1px solid;
    background-color: transparent;
  }

  &--disabled {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none;

    &:hover {
      opacity: 0.6;
    }
  }

  &__icon {
    position: relative;
    width: 12px;
    height: 12px;
    margin-right: 4px;
    object-fit: contain;
    z-index: 100;
  }

  &__text {
    line-height: 1;
  }
}
</style>
